export default __webpack_public_path__ + "static/media/logo.ecbc2294.png";